import React, { useState } from "react";

const MaterialTrendsEdit = () => {
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadSuccess(false);
    setUploadError(false);
  };

  const handleFileUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("materialTrendsPhoto", file);

    try {
      setUploading(true);
      const response = await fetch("/api/cloud/website/insertMaterialTrends", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        console.log(response);
        setUploadSuccess(true);
        setFile(null); // Clear the file input after a successful upload
      } else {
        setUploadError(true);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadError(true);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">Homepage Material Trends</h2>
        <p className="app-muted max-w-2xl text-sm">
          Upload a new featured image to refresh the homepage hero. Use a
          clear, horizontal image under 2MB.
        </p>
      </div>

      <div className="app-surface flex flex-col gap-3 rounded-xl border p-4">
        <label className="text-sm font-medium" htmlFor="materialTrends">
          Select image
        </label>
        <input
          id="materialTrends"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="app-input w-full rounded-xl border p-2 text-sm file:mr-3 file:rounded-full file:border-0 file:bg-sky-500/15 file:px-3 file:py-1 file:text-sm file:font-semibold file:text-sky-700 dark:file:text-sky-300 sm:w-96"
        />
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <button
            type="button"
            onClick={handleFileUpload}
            className="app-btn app-btn-primary self-start"
            disabled={!file || uploading}
          >
            {uploading ? "Uploading..." : "Upload Image"}
          </button>
          {file && !uploading && (
            <p className="app-muted text-xs">Selected: {file.name}</p>
          )}
        </div>

        {uploadSuccess && (
          <p
            role="status"
            className="rounded-xl bg-emerald-500/15 px-3 py-2 text-sm text-emerald-700 dark:text-emerald-300"
          >
            Image uploaded successfully!
          </p>
        )}
        {uploadError && (
          <p
            role="alert"
            className="rounded-xl bg-rose-500/10 px-3 py-2 text-sm text-rose-700 dark:text-rose-300"
          >
            Error uploading image. Please try again.
          </p>
        )}
      </div>
    </div>
  );
};

export default MaterialTrendsEdit;
